import script from "./GerenciadorParceriasAcaoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GerenciadorParceriasAcaoModal.vue?vue&type=script&setup=true&lang=js"

import "./GerenciadorParceriasAcaoModal.vue?vue&type=style&index=0&id=53f6605e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f6605e"]])

export default __exports__